import { render, staticRenderFns } from "./uploadEducation.vue?vue&type=template&id=4bd8c084&"
import script from "./uploadEducation.vue?vue&type=script&lang=js&"
export * from "./uploadEducation.vue?vue&type=script&lang=js&"
import style0 from "./uploadEducation.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports